export default {
  title: "Баланс",
  balanceInfo: {
    title: "Маълумот дар бораи баланс",
    subtitle:
      "RC-ҳои нишон додашаванда дар баланс маблағи интизорӣ дар ҳисобпас баъд аз анҷом додани муомилоти ҳамаамалӣ мебошанд.",
    moreDetailSpoiler: {
      ru: [
        {
          title: "Баланси воқеӣ",
          description: [
            {
              type: "text",
              value:
                "Дар он пур кардани баланс тавассути бонк, бозгаштҳои муомилоти бекоркардашуда, баллҳои ҳисобшуда аз муштариён дохил мешавад. Баъд аз пардохти баллҳо мувофиқи сенарияҳои тақсимоти мукофот, пардохтҳо барои харидани тариф ва хизматҳо, инчунин маблағи «Барои пардохт захирашуда» (агар таъин шуда бошад).",
            },
          ],
        },
        {
          title: "Интизории ҳисобшавӣ",
          description: [
            {
              type: "text",
              value:
                "Баллҳои муштариён, ки то ҳол ба сабаби кам будани маблағҳо дар баланси воқеии шумо ҳисоб нашудаанд. Ҳамчунин сафари муштарӣ (мукофот аз муштариёни рақамии шумо, ки дигар муассисаҳоро ташриф овардаанд) дохил мешавад, ки дар интизори ҳисобшавӣ аст. Интизорӣ ба амал меояд, агар дар ҳисоби шарики, ки муассисааш аз тарафи муштариёни рақамии шумо ташриф оварда шудааст, маблағ кофӣ набошад.",
            },
          ],
        },
        {
          title: "Интизории пардохтӣ",
          description: [
            {
              type: "text",
              value:
                "Баллҳое, ки то ҳол пардохт нашудаанд (мувофиқи сенарияҳои тақсимоти мукофот) ба сабаби кам будани маблағҳо, инчунин агар дар муассиса таъхири ҳисобшавӣ таъин шуда бошад.",
            },
          ],
        },
        {
          title: "Барои бозпас гиранӣ дастрас",
          description: [
            {
              type: "text",
              value:
                "Баланси воқеӣ баъд аз хориҷ кардани маблағҳои интизории пардохтӣ, маблағи амонатӣ, инчунин маблағи «Барои пардохт захирашуда» (агар таъин шуда бошад).",
            },
          ],
        },
        {
          title: "Барои пардохт захирашуда",
          description: [
            {
              type: "text",
              value:
                "Маблағе, ки воқеан дар давраи муомилоти ҳамаамалӣ пардохт хоҳад шуд.",
            },
            {
              type: "text",
              value:
                "Моҳана 2 маротиба дар танзимоти баланс ба маблағи на кам аз 300 RC ва на зиёдтар аз баланси ҷорӣ «Барои бозпас гиранӣ дастрас» таъин мешавад. Барои таъин кардани маблағи пардохтӣ, дар корти баланси шахси ҳуқуқӣ, ки мехоҳед бозпасгирии маблағҳоро барои он танзим кунед, тугмаи «Танзимот»-ро пахш кунед.",
            },
            {
              type: "text",
              value:
                "Агар маблағ то анҷом додани муомилоти ҳамаамалӣ таъин нашавад ва бозпасгирии маблағҳо бо маблағи баланси «Барои бозпас гиранӣ дастрас» фаъол набошад, бозпасгирии маблағҳо сурат намегирад.",
            },
            {
              type: "text",
              value:
                "Тақрибан санаҳои пардохти маблағҳо барои бозпасгирӣ аз баланс - аз 1 то 5 ва аз 16 то 20 ҳар моҳ. Пардохт ба ҳисобҳои ҳисоббарорӣ дар давоми 14 рӯз баъд аз санаи пардохт аз баланс дар ҳисоби шахсӣ анҷом дода мешавад.",
            },
          ],
        },
        {
          title: "Ҳисоботи мувофиқат",
          description: [
            {
              type: "v-text",
              value:
                "Гирифтани ҳисоботи мувофиқат ва корҳои анҷомдодашуда тавассути хизмати дастгирӣ имконпазир аст. Барои ин тавассути шакли фидбэк дар гӯшаи поёни тарафи рости ҳисоби шахсии RC CITY дархост фиристед ё паём ба почтаи электронӣ фиристед <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "Дар дархост зарур аст ишора карда шавад:",
              list: [
                "Рӯйхатсандии давлатӣ (ИНН)",
                "Номи шахси ҳуқуқӣ",
                "Давра, барои он ҳисоботи мувофиқат ё маблағҳо лозим аст, ки барои он ҳисоботи корҳои анҷомдодашуда зарур аст",
              ],
            },
          ],
        },
      ],
      noRu: [
        {
          title: "Баланси воқеӣ",
          description: [
            {
              type: "text",
              value:
                "Дар он пур кардани баланс тавассути бонк, бозгаштҳои муомилоти бекоркардашуда, баллҳои ҳисобшуда аз муштариён дохил мешавад. Баъд аз пардохти баллҳо мувофиқи сенарияҳои тақсимоти мукофот ва пардохтҳо барои харидани тариф ва хизматҳо.",
            },
          ],
        },
        {
          title: "Интизории ҳисобшавӣ",
          description: [
            {
              type: "text",
              value:
                "Баллҳои муштариён, ки то ҳол ба сабаби кам будани маблағҳо дар баланси воқеии шумо барои анҷом додани муомилоти ҳамаамалӣ ҳисоб нашудаанд. Ҳамчунин сафари муштарӣ (мукофот аз муштариёни рақамии шумо, ки дигар муассисаҳоро ташриф овардаанд) дохил мешавад, ки дар интизори ҳисобшавӣ аст. Интизорӣ ба амал меояд, агар дар ҳисоби шарики, ки муассисааш аз тарафи муштариёни рақамии шумо ташриф оварда шудааст, маблағ кофӣ набошад.",
            },
          ],
        },
        {
          title: "Интизории пардохтӣ",
          description: [
            {
              type: "text",
              value:
                "Баллҳое, ки то ҳол пардохт нашудаанд (мувофиқи сенарияҳои тақсимоти мукофот) ба сабаби кам будани маблағҳо, инчунин агар дар муассиса таъхири ҳисобшавӣ таъин шуда бошад.",
            },
          ],
        },
        {
          title: "Барои бозпас гиранӣ дастрас",
          description: [
            {
              type: "text",
              value:
                "Баланси воқеӣ баъд аз хориҷ кардани маблағҳои интизории пардохтӣ ва маблағи амонатӣ.",
            },
          ],
        },
        {
          title: "Ҳисоботи мувофиқат",
          description: [
            {
              type: "v-text",
              value:
                "Гирифтани ҳисоботи мувофиқат ва корҳои анҷомдодашуда тавассути хизмати дастгирӣ имконпазир аст. Барои ин тавассути шакли фидбэк дар гӯшаи поёни тарафи рости ҳисоби шахсии RC CITY дархост фиристед ё паём ба почтаи электронӣ фиристед <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a>",
            },
            {
              type: "list",
              title: "Дар дархост зарур аст ишора карда шавад:",
              list: [
                "Рӯйхатсандии давлатӣ (ИНН)",
                "Номи шахси ҳуқуқӣ",
                "Давра, барои он ҳисоботи мувофиқат ё маблағҳо лозим аст, ки барои он ҳисоботи корҳои анҷомдодашуда зарур аст",
              ],
            },
          ],
        },
      ],
    },
  },
  withdrawalInstructionName:
    "Дастур оид ба бозпас гирани маблағҳо аз ҳисоби шахсии RC CITY",
  reservedForPayment: "Барои пардохт захирашуда",
  withdrawalOfFund: "Бозпас гирани маблағҳо",
  power: {
    on: "Фаъол",
    off: "Ғайрифаъол",
  },
  actualBalance: "Баланси воқеӣ",
  expectedCredited: "Интизории ҳисобшавӣ",
  expectedDebiting: "Интизории пардохтӣ",
  availableWithdrawal: "Барои бозпас гиранӣ дастрас",
  statusText: {
    needAdjustPaymentMethod:
      "Барои бозпас гирани маблағҳо зарур аст роҳи пардохтро танзим кунед",
    bySumReservedOnBalance:
      "Бо маблағе, ки то лаҳзаи пардохт дар баланс захира шудааст",
    bySumAvailableToWithdrawal:
      "Бо маблағи «Барои бозпас гиранӣ дастрас» дар лаҳзаи анҷом додани муомилоти ҳамаамалӣ",
  },

  topupModal: {
    title: "Маблағи пуркуниро ишора кунед",
    entityPayer: "Шахси ҳуқуқӣ - пардохткунанда",
    topupSum: "Маблағи пуркунӣ",
  },
  createAndDownloadAccount: "Ташкил ва боргирӣ кардани ҳисоб",
  byReservedSum: "Бо маблағи «Барои пардохт захирашуда»",
  byAvailableSum: "Бо маблағи «Барои бозпас гиранӣ дастрас»",
  bySettedSum: "Бо маблағи таъиншуда",
  bySettedSumDesc:
    "Маблағҳо то лаҳзаи пардохт захира карда мешаванд, онҳоро наметавон барои харидани тариф ва хизматҳо истифода бурд, зеро баланси воқеӣ ба қадри таъиншуда коҳиш хоҳад ёфт. Ин роҳ дастрас нест, вақте ки қимати маблағи «Барои бозпас гиранӣ дастрас» камтар аз 300 RC бошад.",
  byAvailableSumDesc:
    "Бозпасгирии маблағҳо бо маблағе баробар ба қимати баланси «Барои бозпас гиранӣ дастрас» дар лаҳзаи анҷом додани муомилоти ҳамаамалӣ ба шарте ки он на кам аз 300 RC бошад, анҷом дода мешавад.",
  success: "Муваффақиятом",
  settings: {
    title: "Танзимоти бозпас гирани маблағҳо",
    banner: {
      inProgress: {
        title: "Пардохтҳо идома доранд",
        description: [
          "Дар давраи пардохтҳо тағири танзимоти бозпас гирани маблағҳо дастрас нест.",
          "Танзим кардани танзимотҳо барои пардохти навбатӣ пас аз анҷоми раванди ҷорӣ бозпасгирии маблағҳо имконпазир хоҳад буд.",
        ],
      },
      inPending: {
        title: "Интизории бозпас гирани маблағҳо",
        description: [
          "Он мувофиқи шартнома боби 4.6 анҷом дода мешавад. Тақрибан санаҳои пардохти маблағҳо барои бозпасгирӣ аз баланс - аз 1 то 5 ва аз 16 то 20 ҳар моҳ. Пардохт ба ҳисобҳои ҳисоббарорӣ дар давоми 14 рӯз баъд аз санаи пардохт аз баланс дар ҳисоби шахсӣ анҷом дода мешавад.",
          "Барои бекор кардани гирифтани пардохт, тағири роҳи пардохт ё таъин кардани маблағи дигар, тугмаи «Ғайрифаъол кардани бозпас гирани маблағҳо»-ро пахш кунед.",
        ],
      },
      inDisabled: {
        title: "Бозпас гирани маблағҳо ғайрифаъол аст",
        description: [
          "Барои бозпас гирани маблағҳо роҳи пардохтро интихоб кунед ва танзимотҳоро татбиқ кунед. Пардохт мувофиқи шартнома боби 4.6 анҷом дода мешавад.",
          "Тақрибан санаҳои пардохти маблағҳо барои бозпасгирӣ аз баланс - аз 1 то 5 ва аз 16 то 20 ҳар моҳ. Пардохт ба ҳисобҳои ҳисоббарорӣ дар давоми 14 рӯз баъд аз санаи пардохт аз баланс дар ҳисоби шахсӣ анҷом дода мешавад.",
          "Агар чизе интихоб накарда шавад, дар давраи ишорашуда бозпасгирии маблағҳо барои ин шахси ҳуқуқӣ анҷом дода нахоҳад шуд.",
        ],
      },
    },
    paymentMethod: "Роҳи пардохт",
    sumToBePaid: "Маблағи пардохтӣ",
    validSumTobePaidValid:
      "Метавон маблағи на кам аз 300 RC ва на зиёдтар аз қимати ҷорӣ баланси «Барои бозпас гиранӣ дастрас» таъин кард",
    entity: "Шахси ҳуқуқӣ",
    notSelectedNoPayment: "Интихоб нашудааст, пардохт анҷом дода намешавад",
    bank: {
      BIC: "БИК бонк",
      naming: "Номи бонк",
      paymentAccount: "Рақами ҳисоби ҳисоббарорӣ",
      corpAccount: "Ҳисоби корӣ",
      depositAmount: "Маблағи амонатӣ",
      depositAmountHint:
        "Миқдори минималии боқимонда дар ҳисоб. Маблағе, ки дар вақти бозпас гирани маблағҳо дар баланс боқӣ мемонад.",
      changeDetails: "Тағири маълумотҳо",
    },
    disableWithdrawal: "Ғайрифаъол кардани бозпас гирани маблағҳо",
    disabledWithdrawalForDefinEntity:
      "Бозпас гирани маблағҳо барои шахси ҳуқуқӣ {entityName} ғайрифаъол карда шуд",
  },
  editPaymentModal: {
    title: "Мехоҳед маълумоти бонкӣ ё маблағи амонатиро тағир диҳед?",
    subtitle:
      "Барои таҳрир кардан шумо ба зербахши «Шахсон ҳуқуқӣ» гузаронида мешавед. Баъд аз ворид кардани тағирот ба саҳифаи «Баланс» баргардед, то бозпас гирани маблағҳоро бо маълумоти нав танзим кунед.",
    toEdit: "Ба таҳрир",
  },
  resetPaymentModal: {
    title: "Танзимоти бозпас гирани маблағҳо бекор карда шаванд?",
    subTitle:
      "Дар натичаи пахш кардани тугмаи «Ҳа, бекор кардан» танзимоти бозпас гирани маблағҳо бекор карда мешаванд. Пардохти маблағҳои пулӣ барои ин шахси ҳуқуқӣ анҷом дода нахоҳад шуд.",
    yesCancel: "Ҳа, бекор кардан",
  },
  disabledPaymentModal: {
    title: "Ғайрифаъол кардани бозпас гирани маблағҳоро тасдиқ кунед",
    subtitle: {
      withFullWithdrawal: [
        "Пахш кардани тугмаи «Тасдиқ кардан», маблағи пештар таъиншуда барои пардохт аз захира хориҷ карда мешавад. Пас аз ин шумо метавонед роҳи пардохтро тағир диҳед ё маблағи нави пардохтро таъин кунед.",
        "Агар роҳи нави бозпас гиранӣ интихоб карда нашавад, барои ин шахси ҳуқуқӣ пардохт анҷом дода нахоҳад шуд.",
        "Муҳим! Таъин кардани маблағи нави пардохт танҳо дар доираи баланси «Барои бозпас гиранӣ дастрас» имконпазир хоҳад буд, ки қимати он пас аз бекор кардани захира аз ҳозира фарқ кунад.",
      ],
      withoutFullWithdrawal: [
        "Пас аз ғайрифаъол кардан, он бори дигар фаъол кардан ё роҳи дигари пардохтро интихоб кардан имконпазир хоҳад буд.",
        "Агар роҳи нави бозпас гиранӣ интихоб карда нашавад, барои ин шахси ҳуқуқӣ пардохт анҷом дода нахоҳад шуд.",
      ],
    },
  },
};
